module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_17"
    }
  }, [_c('span', [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e136317"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c4_r1#d6e4",
      "id": "d7e4"
    }
  }, [_vm._v("1 "), _c('br'), _c('br'), _c('i', [_vm._v("The Deadly Dissection ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph",
    attrs: {
      "id": "d7e137117"
    }
  }, [_c('span', [_c('i', [_vm._v("The essence of all comedy is would you hit a lady with a baby? No, I’ d hit her with a brick.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extbd",
    attrs: {
      "id": "d7e137917"
    }
  }, [_c('span', [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E. E. CUMMINGS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e138417"
    }
  }, [_c('span', [_vm._v("The problem of defining what produces laughter involves a degree of wrestling with language. “A Hottentot and a Dane might hammer out an agreed definition of beauty,” Lewis wrote,")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e139517"
    }
  }, [_c('span', [_vm._v("and in that sense, lexically, “mean” the same by it. Yet the one might continue, in a different sense, to “mean” blubber lips, woolly hair, and fat paunch while the other “meant” a small mouth, silky hair, “white and red,” and a slender waist. And two men who agree about the [lexical] “meaning” of comic would not necessarily find the same things funny."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d6",
      "id": "a6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e142017"
    }
  }, [_c('span', [_vm._v("Comedy, as the great eighteenth-century lexicographer Dr. Samuel Johnson once remarked, “has been particularly unpropitious to definers.” One reason for humankind’s failure to surround and capture the elusive concept can be attributed to Aristotle’s observation in "), _c('i', [_vm._v("The Poetics")]), _vm._v(": “Comedy has had no history, because it was not at first treated seriously.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d7",
      "id": "a7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Chad Walsh echoed Aristotle when he described the “awkward double predicament of trying to take the comic seriously and the serious comically. . . . To write seriously about the comic is to fail to practice what one preaches; and yet to practice what one preaches is to fail to be taken seriously.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d8",
      "id": "a8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e146817"
    }
  }, [_c('span', [_vm._v("Another problem is what Lewis called the human dilemma of knowing:")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_18"
    }
  }, [_c('span', [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e148118"
    }
  }, [_c('span', [_vm._v("Either to taste and not to know or to know and not to taste—or, more strictly, to lack one kind of knowledge because we are in an experience or to lack another kind because we are outside it. As thinkers we are cut off from what we think about; as tasting, touching, willing, loving, hating, we do not clearly understand. . . . You cannot study pleasure in the moment of the nuptial embrace, nor repentance while repenting, nor analyze the nature of humor while roaring with laughter."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d9",
      "id": "a9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e151218"
    }
  }, [_c('span', [_vm._v("Lewis defined the two experiences or ways of knowing with two French verbs: "), _c('i', [_vm._v("savoir ")]), _vm._v("and "), _c('i', [_vm._v("connaitre")]), _vm._v(". "), _c('i', [_vm._v("Savoir ")]), _vm._v("is to know "), _c('i', [_vm._v("about ")]), _vm._v("something—to examine it, study it, analyze it. Lewis wrote: “But I have an idea that the true analysis of a thing ought not to be so like the thing itself. I should not expect a true theory of the comic to be itself funny.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d10",
      "id": "a10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e155018"
    }
  }, [_c('span', [_vm._v("Yet the contemplation of an object, its "), _c('i', [_vm._v("savoir")]), _vm._v(", is only one epistemological way. The other method of knowing—"), _c('i', [_vm._v("connaitre")]), _vm._v("—is to enjoy an object, to become acquainted with it intimately, to experience and taste it. In “Meditation in a Toolshed,” Lewis called this, in essence, looking "), _c('i', [_vm._v("along ")]), _vm._v("an experience, being immersed in it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d11",
      "id": "a11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" For example, the spontaneous humor and banter of friends gathered on the eve of a holiday offer one the "), _c('i', [_vm._v("taste")]), _vm._v("—and not merely the outward knowledge—of humor.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e159618"
    }
  }, [_c('span', [_vm._v("A related problem in catching and defining such a slippery notion as humor is that one can never get a firm grip on it. Like an elf in a forest, it is gone as soon as one turns to see it. Indeed, there is a curious and frustrating psychological law that says our postures or attitudes toward something often inhibit the very thing they are meant to facilitate. Lewis noted: “You can’t, in most things, get what you want if you want it too desperately. ‘Now! Let’s have a real good talk’ reduces everyone to silence, ‘I must get a good sleep tonight’ ushers in hours of wakefulness.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d12",
      "id": "a12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e163018"
    }
  }, [_c('span', [_vm._v("This happens, too, with laughter. The king’s command to the jester to be funny ultimately may be disastrous if he does not "), _c('i', [_vm._v("seriously ")]), _vm._v("fulfill his duty. Similarly, the comic writer or actor is dared by his or her audience to be funny. Yet the quest to lasso wild and bucking laughter and keep it frisky in its stall is a futile one. As soon as one ropes and trains laughter, it becomes a manageable, wooden hobbyhorse. Nevertheless, as we in the enterprise of this book attempt to corral and tame Lewis’s laughter, observe and study it, we can still hope for the animal to surprise us with a snort or kick.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_19"
    }
  }, [_c('span', [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e166919"
    }
  }, [_c('span', [_vm._v("Yet even with all these caveats in place, categorization for an academic is irresistible—and I have not resisted (nor did Lewis, as shall be shown) putting Lewis’s types of laughter into categories. Comedy can be classified in a variety of ways. It can be divided, for example, according to whether it is funny or not. But such a distinction depends upon the audience. Shakespeare noted that “a jest’s prosperity lies in the ear of him that hears it, never in the tongue of him that makes it.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d13",
      "id": "a13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" This may be why most of us laugh at our own jokes so enthusiastically; we know our audience. We’ve spent years fine-tuning our humor to our crowd of one.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e171019"
    }
  }, [_c('span', [_vm._v("Lewis partially adopted this approach in reminding his brother, Warnie, “you know how one classifies jokes according to the people one wants to tell them to.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d14",
      "id": "a14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Lewis shared with his brother a certain dry wit. Having endured a wild collection of absurdities of life with their father, the brothers possessed a sympathetic humor; they knew what each other would find amusing and funny. In a letter to his brother, Lewis told a funny, true story that embodied this shared perspective: At a college dinner, a certain undergraduate, presumably drunk, “covered the face of his neighbor with potatoes, his neighbor being a total stranger.” Being hauled before the proctors (the disciplinary body in British universities), the culprit’s only excuse was: “I couldn’t think of anything else to do.” Lewis appealed to Warnie’s sense of ironic delight in imagining this")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e175819"
    }
  }, [_c('span', [_vm._v("transference of the outrage from the class of positive to that of negative faults; as though it proceeds entirely from a failure of the inventive faculty or a mere poverty of the imagination. One ought to be careful of sitting near one of these unimaginative men . . . one thinks of the Mohawk bashing your hat over your eyes with the words, “Sorry old chap, I know it’s a bit hackneyed, but I can’t think of anything better”—or of some elderly gentleman exclaiming testily, “Ah what all these young men lack now-a-days is initiative” as he springs into the air from the hindward pressure of a pin."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d15",
      "id": "a15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_20"
    }
  }, [_c('span', [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e179720"
    }
  }, [_c('span', [_vm._v("Lewis also likened his division of comedy to his categories of religions and soups: the thick and the clear. The "), _c('i', [_vm._v("thick ")]), _vm._v("includes all humor that deals with the animal side of human nature—that which grows out of the earth and blood and sex of men and women. The "), _c('i', [_vm._v("clear")]), _vm._v(", on the other hand, encompasses wit, the philosophical and the intellectual, the rational realm of human nature. True comedy, ideally, brings together both—child and man, savage and citizen, head and belly."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d16",
      "id": "a16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Yet this system of categorizing comedy can’t seem to avoid pigeonholing humor. How can one tell when laughter strikes predominantly the child or the adult? Aren’t the two worlds neatly and precisely distinguishable? Is there a level of intelligence and sophistication that separates the two? It is better to ask: Must farce and slapstick remain strictly in the province of the juvenile? Do not many ribald jokes depend on an incongruous intellectual twist? Consider the evangelist’s unwitting play on words in invoking the parable of the ten virgins before his audience of male, celibate seminarians: “Tell me, would you rather be with the wise virgins at the wedding feast or with the foolish virgins in the dark?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e187020"
    }
  }, [_c('span', [_vm._v("As we grow in knowledge and understanding (though our minds ultimately operate in reverse, bringing on a jolly senility and forgetfulness), we do not simply add clear wit to thick humor. Indeed, as adults we may joyfully discover subtle ironies and paradoxes, but even a young child can delightedly recognize incongruity.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e188920"
    }
  }, [_c('span', [_vm._v("Lewis’s recommendation of the two ways of thinking might be profitably applied as well to laughing. As he pointed out, “One can’t think straight unless you are cool. But then neither can you think deep if you are. I suppose one must try every problem in both states. You remember that the ancient Persians debated everything twice: once when they were drunk and once when they were sober.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Lind_9781595554796_epub_c50_r1#d17",
      "id": "a17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" He might easily have been speaking of clear and sober wit and intoxicating and thick comedy.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "Page_21"
    }
  }, [_c('span', [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e193021"
    }
  }, [_c('span', [_vm._v("Ultimately, however, the categories that will govern this study are those defined and described in Lewis’s "), _c('i', [_vm._v("The Screwtape Letters")]), _vm._v(". In the eleventh letter to a junior devil, Lewis tinkered with four origins of laughter, which he labeled "), _c('i', [_vm._v("joy")]), _vm._v(", "), _c('i', [_vm._v("fun")]), _vm._v(", "), _c('i', [_vm._v("the joke proper")]), _vm._v(", and "), _c('i', [_vm._v("flippancy")]), _vm._v(". It is my purpose in this book to survey these categories, to see what Lewis had to say about them, and to examine how he used them in his own writings. A sketchy preview will draw, in broad brush strokes, the laughter of joy as a positive, spiritual experience; the laughter of fun or play as a buoyant physical expression; the laughter of the joke proper as a cognitive exercise; and the laughter of satire and flippancy as social and antisocial exchanges, respectively. A postscript on the place of love and laughter will end our study with a nice, warm glow.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1f0ba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lind_9781595554796_epub_c8_r1.vue
// module id = 78
// module chunks = 0